import { units } from '@ui/css';
import { colors } from '@ui/kit/design-tokens';
import { combineTokens, makeScaleableToken } from '@utils/css';

combineTokens("--in-table", {
  containerPadding: [units.px(30), makeScaleableToken],
  background: colors.tertiary(),
  cellBackground: colors.tertiary({
    mix: {
      with: colors.gray.sim00,
      ratio: 0.4
    }
  })
});
const wrapper = "_35sw26kxah";
const scroller = "_35ssuf3kmn";
const table = "_35stpceccs";
const thead = "_35st1g215uq";
const tableHeadingCell = "_35stslb5l7";
const cell = "_35sc1f095nm";
const cellContent = "_35scnwzqp3";

export { cell, cellContent, scroller, table, tableHeadingCell, thead, wrapper };
import "./_task.in-table.style.linaria.module.css";
//# sourceMappingURL=_task.in-table.style.js.map
